// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3xrJ3","container":"styles_container__27d0R","title":"styles_title__2O_1X","wrapper":"styles_wrapper__1c5F6","answer":"styles_answer__3_8bq"};